import React, { useCallback } from 'react';
import { Button, Modal } from 'react-bootstrap';

import { useLocalization } from '../../contexts/LocalizationContext';
import { useForm } from '../../hooks/useForm';
import { replaceLocation } from '../../utility';

import SelectField from '../../components/forms/fields/SelectField';
import BaseForm from '../../components/Fields/BaseForm';

export function SelectOrganizationModal({ tenants, handleClose }) {
  const { locale, localize } = useLocalization();
  const form = useForm();

  const handleLogin = useCallback(
    async (values) => {
      if (!values || !values?.tenant?.url) {
        return;
      }
      let localizedUrl = new URL(values?.tenant?.url);
      localizedUrl.searchParams.set('lang', locale);
      replaceLocation(localizedUrl);
    },
    [form?.values]
  );

  const disabled = !form?.values?.tenant?.id;

  return (
    <>
      <BaseForm form={form} onSubmit={handleLogin}>
        <Modal.Header closeButton closeLabel={localize('common.close', { editable: false })}>
          <Modal.Title id='modal-title'>
            <span style={{ color: 'black' }}>
              {localize('login.select.tenant')}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {tenants && tenants.length ? (
            <SelectField
              label={localize('nav.link.organizations')}
              htmlFor='tenant-selection'
              controlId='tenant-selection'
              placeHolder={localize('common.select')}
              autoFocus
              id='tenant-selection'
              {...form.select('tenant', {
                options: tenants,
                optionValue: (tenant) => tenant.id,
                optionLabel: (tenant) => localize(tenant?.name)
              })}
            />
          ) : (
            <p aria-live='polite' id='error-message'>
              {localize('error.tenants.not.found')}
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='outline-secondary'
            onClick={handleClose}
            aria-label={localize('common.close')}>
            {localize('common.close')}
          </Button>
          <Button
            type='submit'
            disabled={disabled}
            aria-label={localize('login.identify')}>
            {localize('login.identify')}
          </Button>
        </Modal.Footer>
      </BaseForm>
    </>
  );
}
